import { TProps } from './types/TProps';

const monthClassName = [
  'current-month min-w-0 flex-[1_1_auto] text-center text-[11px] font-medium leading-[26px]',
  'text-[var(--color-form-field-datepicker-text,var(--color-form-field-text,var(--color-text)))]',
].join(' ');

export const FormFieldDatePickerHeaderMonth = ({ className = '', children }: TProps) => (
  <span className={[monthClassName, className].filter(Boolean).join(' ')}>{children}</span>
);
